import React from 'react';

import Contexts from '../contexts';

const useAuth = () => {
  return React.useContext(Contexts.AuthContext);
};

export default useAuth;
